import { render } from "./TalkDetail.vue?vue&type=template&id=4f56eb66&scoped=true"
import script from "./TalkDetail.vue?vue&type=script&lang=js"
export * from "./TalkDetail.vue?vue&type=script&lang=js"

import "./TalkDetail.vue?vue&type=style&index=0&id=4f56eb66&scoped=true&lang=css"

import exportComponent from "/Users/apple/Projects/opm/yuzhangmen/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f56eb66"]])

export default __exports__